import { useTranslation } from 'react-i18next';
import { userService } from '../../../services/User/userService';
import { useError } from '../../../providers/useError';

export const useUnblockUser = () => {
  const { handleError } = useError();
  const { t } = useTranslation('users');

  const unblockErrorMap = new Map([[409, t('error.cannot-unblock-after-termination')]]);

  const unblockUser = (userId: number, onUnblocked?: () => void) => {
    userService
      .unblockUser(userId)
      .then(onUnblocked)
      .catch(error => handleError(error, t('error.generic'), unblockErrorMap));
  };

  return { unblockUser };
};
